import { Component, Input, OnInit } from "@angular/core";

import { CarouselResponsiveOption } from "@models/prime-ng";
import { ProducerUser } from "@models/user";
import { CarouselModule } from "primeng/carousel";
import { SkeletonModule } from "primeng/skeleton";
import { ProducerCardComponent } from "../../../shared/components/producer-card/producer-card.component";

@Component({
  selector: "app-followed-producers",
  imports: [SkeletonModule, ProducerCardComponent, CarouselModule],
  templateUrl: "./followed-producers.component.html",
  styleUrl: "./followed-producers.component.scss",
})
export class FollowedProducersComponent implements OnInit {
  @Input() followedProducers: ProducerUser[] | null = null;
  responsiveOptions: CarouselResponsiveOption[] | undefined;

  ngOnInit(): void {
    this.responsiveOptions = [
      {
        breakpoint: "1199px",
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: "991px",
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: "767px",
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
}
